import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from "@angular/core";
import { RequestBwt } from "../../../models/request/request-bwt";
import { KeyValueObject } from "../../../models/core/KeyValueObject";
import { LookupService } from "../../../services/lookup.service";
import { RequestTypeWithCategoriesModel } from "../../../models/request/request-type-with-categories-model";
import { RequestCategotyWithTypesModel } from "../../../models/request/request-categoty-with-types-model";
import { RequestCategoryService } from "../../../services/request-categoty.service";
import { RequestTypeService } from "../../../services/request-type.service";
import { HierarchyLookupModel } from "../../../models/core/HierarchyLookupModel";
import { NgForm } from "@angular/forms";
import { RequestsService } from "../../../services/requests.service";
import { forkJoin, Observable } from "rxjs";
import { CreateContragentComponent } from "../../contragents/create-contragent/create-contragent.component";
import { DialogService } from "@progress/kendo-angular-dialog";
import { ContragentsService } from "../../../../categories/contragents/contragents.service";
import { ContragentWithContactDto } from "../../../models/contragent/contragent-with-contact-dto";
import { UsersService } from "../../../../admin/users/users.service";
import { CustomerObjectsService } from "../../../../categories/customer-objects/customer-objects.service";
import { ContragentType, RequestType } from "../../../enums";
import { DataSourceRequestState } from "@progress/kendo-data-query";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { SignalRNotificationsService } from "../../../services/signalr-notifications.service";
import { RequestStatusWorkflowTransitionsComponent } from "./request-status-workflow-transitions/request-status-workflow-transitions.component";
import { CreateRequestWaterSamplingActComponent } from "../../workflow-transitions/create-request-water-sampling-act/create-request-water-sampling-act.component";
import { CreateRequestWaterSamplingComponent } from "../../workflow-transitions/create-request-water-sampling/create-request-water-sampling.component";
import { PaymentStatusEnum } from "../../../enums/payment-status.enum";
import { PaymentTypeEnum } from "../../../enums/payment-type.enum";
import { PaymentsService } from "../../../services/payments-service";
import { DocumentSender } from "../../document-sender/document-sender.component";
import { AppService } from "../../../../app.service";
import { RequestFilesService } from "../../../services/request-files.service";
import { AttachmentsService } from "../../../services/attachments.service";
import { Sended } from "../../../models/mail-sender/sended";
import { NotificationService } from "../../../../core/services/notification.service";
import { NotificationType } from "../../../../core/services/notification-type";
import Swal from 'sweetalert2';
import { RequestClaimDevice } from "../../../models/request/request-claim-device";
import { RequestDevicesService } from "../../../services/request-devices.service";
import { ReclamationDevicesService } from "../../../services/reclamation-devices.service";
import { ReclamationDeviceDto } from "../../../models/reclamation/reclamation-device.dto";
import { GridComponent } from "@progress/kendo-angular-grid";
import { RequestReclamationDeviceDto } from "../../../models/reclamation/request-reclamation-device.dto";
import { ReclamationDeviceDeviceModelDto } from "../../../models/reclamation/reclamation-device-device-model.dto";
import { hasUtmTags } from "../../../utils/utm-tag-parser";


@Component({
	selector: 'request-page-main',
	templateUrl: './request-page-main.component.html',
	styleUrls: ['./request-page-main.component.scss',
		'../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
		'../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
	],
	encapsulation: ViewEncapsulation.None,
})
export class RequestPageMainComponent implements OnInit {

	@ViewChild('entityForm') public entityForm: NgForm;
	@ViewChild('reclamationDevicesGrid') public reclamationDevicesGrid: GridComponent;

    @Input() request: RequestBwt;
	@Input() dataSaving: boolean;
	@Input() blockHeight: number;

	@Output() requestUpdateEvent: EventEmitter<RequestBwt> = new EventEmitter<RequestBwt>();

	requestStatuses: KeyValueObject[] = [];
    dependentRequestCategories: RequestCategotyWithTypesModel[] = [];
    requestTypes: RequestTypeWithCategoriesModel[] = [];
    requestCategories: RequestCategotyWithTypesModel[] = [];
	userGroups: HierarchyLookupModel[] = [];
	performersByGroup: KeyValueObject[] = [];
	customerObjects: KeyValueObject[] = [];
	serviceCenters: KeyValueObject[] = [];
	problems: KeyValueObject[] = [];
	contragents: KeyValueObject[] = [];
	carriers: KeyValueObject[] = [];
	marketPlaces: KeyValueObject[] = [];
	reclamationProductGroups: KeyValueObject[] = [];
	reclamationDevices: ReclamationDeviceDto[] = [];
	reclamationDevicesDropdownData: KeyValueObject[] = [];
	initTypes: KeyValueObject[] = [];
	reclamationDeviceModels: ReclamationDeviceDeviceModelDto[] = [];
	requestReclamationDevices: RequestReclamationDeviceDto[] = [];
	responsibleUsers: KeyValueObject[] = [];
	costCenters: KeyValueObject[] = [];
	paymentTypes: KeyValueObject[] = [];

	selectedContragent: ContragentWithContactDto = null;
	requestClaimDevices: RequestClaimDevice[] = [];

	descriptionInputRows: number = 1;
	isEditing: boolean = false;
	savedServiceCenterId: number = null;
	requestWaterSamplingDataLoading: boolean = false;
	invoiceLoading: boolean = false;
	requestClaimDevicesLoading: boolean = false;
	utmCardOpened: boolean = false;

	readonly hasUtmTags = hasUtmTags;

	dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };

	contragentsState: DataSourceRequestState = {
		filter: { logic: "and", filters: [{ 
			field: "ContragentTypeId", 
			operator: "eq", 
			value: ContragentType.bankEquer 
		}] }
	};

	constructor(
		private requestsService: RequestsService,
		private lookupService: LookupService,
		private requestTypeService: RequestTypeService,
		private requestCategoryService: RequestCategoryService,
		private contragentsService: ContragentsService,
		private dialogService: DialogService,
		private usersService: UsersService,
		private customerObjectsService: CustomerObjectsService,
		private signalR: SignalRNotificationsService,
		private paymentsService: PaymentsService,
		private appService: AppService,
		private attachmentsService: AttachmentsService,
		private notificationService: NotificationService,
		private requestDevicesService: RequestDevicesService,
		private reclamationDevicesService: ReclamationDevicesService
	) { }

	ngOnInit(): void {
		this.initData();

		this.prepareRequestData();
	}

	initData() {
		const requestTypes$ = this.requestTypeService.getRequestTypesWithCategories();
		const requestCategories$ = this.requestCategoryService.getRequestCategoriesWithTypes();
		const selectedContragent$ = this.contragentsService.getContragentWithContact(this.request.customerContragentId);
		const customerObjects$ = this.customerObjectsService.getCustomerObjectsByContragent(this.request.customerContragentId);
		const problems$ = this.requestsService.getRequestProblems(this.request.requestId);
		const contragents$ = this.lookupService.getData("contragents", this.contragentsState);
		const serviceCenters$ = this.customerObjectsService.getAssignableServiceCenters();
		const requestStatuses$ = this.lookupService.getData("request-statuses", null);
		const userGroups$ = this.lookupService.getHierarchyData("user-groups", null);
		const responsibleUsers$ = this.usersService.getRequestTypeResponsibleUsers(this.request.requestTypeId);
		const paymentTypes$ = this.lookupService.getData('payment-types', null);
		const initTypes$ = this.lookupService.getDataForCombobox('init-types', null);
		const costCenters$ = this.lookupService.getData("cost-centers", null);

		forkJoin(
			requestTypes$, 
			requestCategories$, 
			selectedContragent$, 
			customerObjects$, 
			problems$, 
			contragents$, 
			serviceCenters$,
			requestStatuses$,
			userGroups$,
			responsibleUsers$,
			paymentTypes$,
			initTypes$,
			costCenters$)
		.subscribe(([
			requestTypes, 
			requestCategories, 
			selectedContragent, 
			customerObjects, 
			problems, 
			contragents, 
			serviceCenters,
			requestStatuses,
			userGroups,
			responsibleUsers,
			paymentTypes,
			initTypes,
			costCenters]) => 
		{
			this.requestTypes = requestTypes;
			this.requestCategories = requestCategories;
			this.dependentRequestCategories = this.requestCategories.filter(x => 
				x.requestTypeIds.some(rt => rt == this.request.requestTypeId) && !x.disabledForCurrentUser);
			this.selectedContragent = selectedContragent;
			this.customerObjects = customerObjects;
			this.problems = problems.data;
			this.contragents = contragents;
			this.serviceCenters = serviceCenters;
			if (this.request.serviceCenterId
				&& !this.serviceCenters.some(s => s.id === this.request.serviceCenterId)) {
				this.serviceCenters = [
					...this.serviceCenters,
					new KeyValueObject(
						this.request.serviceCenterId,
						this.request.serviceCenterName || ('СЦ #' + this.request.serviceCenterId)
					)
				];
			}
			this.requestStatuses = requestStatuses;
			this.userGroups = userGroups;
			this.responsibleUsers = responsibleUsers;
			this.paymentTypes = paymentTypes;
			this.initTypes = initTypes;
			this.costCenters = costCenters;
			this.applySkipInventoryPaymentType();
		});

		if (this.isReclamation) {
			const carriers$ = this.lookupService.getData("carriers", null);
			const deviceMarketPlaces$ = this.lookupService.getData('device-market-places', null);
			const reclamationProductGroups$ = this.lookupService.getData('reclamation-product-groups', null);
        	const reclamationDevices$ = this.reclamationDevicesService.getAll();
			const reclamationDeviceModels$ = this.reclamationDevicesService.getAllReclamationDeviceModels();

			forkJoin([carriers$, deviceMarketPlaces$, reclamationProductGroups$, reclamationDevices$, reclamationDeviceModels$])
			.subscribe(([carriers, deviceMarketPlaces, reclamationProductGroups, reclamationDevices, reclamationDeviceModels]) => {
				this.requestReclamationDevices = [];
				this.carriers = carriers;
				this.marketPlaces = deviceMarketPlaces;
				this.reclamationProductGroups = reclamationProductGroups;
				this.reclamationDevices = reclamationDevices;
				this.reclamationDeviceModels = reclamationDeviceModels;
				this.reclamationDevicesDropdownData = reclamationDevices.map(x => new KeyValueObject(x.reclamationDeviceId, x.name));

				if (this.request.reclamationDeviceId) {
					let reclamationDevice = this.reclamationDevices.find(x => x.reclamationDeviceId == this.request.reclamationDeviceId);
					let requestReclamationDevice = {
						reclamationDeviceId: reclamationDevice.reclamationDeviceId,
						reclamationProductGroupId: reclamationDevice.reclamationProductGroupId,
					} as RequestReclamationDeviceDto;
					this.requestReclamationDevices.push(requestReclamationDevice);
				}
			});

			this.loadRequestClaimDevices();
		}

		this.loadPerformerUsers(this.request.performerUserGroupId);
	}

	loadContragent() {
		this.contragentsService.getContragentWithContact(this.request.customerContragentId).subscribe(resp => {
			this.selectedContragent = resp;
		});
	}

	loadRequestWaterSamplingData() {
		this.requestWaterSamplingDataLoading = true;
		this.requestsService.getRequestWaterSamplingData(this.request.requestId).subscribe(resp => {
			if (resp && resp.data && resp.isSuccessful) {
				this.request.requestWaterSamplingData = resp.data;
				this.requestWaterSamplingDataLoading = false;
			}
			else {
				this.requestWaterSamplingDataLoading = false;
			}
		})
	}

	saveChanges() {
		this.dataSaving = true;
		this.requestsService.getById(this.request.requestId).subscribe(resp => {
			let entity = resp.entity;
			entity.requestTypeId = this.request.requestTypeId;
			entity.requestCategoryId = this.request.requestCategoryId;
			entity.performerUserGroupId = this.request.performerUserGroupId;
			entity.performerUserId = this.request.performerUserId;
			entity.createdDate = this.request.createdDate;
			entity.finishDate = this.request.finishDate;
			entity.description = this.request.description;
			entity.customerObjectId = this.request.customerObjectId;
			entity.claimId = this.request.claimId;
			entity.serviceCenterId = this.request.serviceCenterId;
			entity.resolution = this.request.resolution;
			entity.claimedDeviceQuantity = this.request.claimedDeviceQuantity;
			entity.ammountOfDamage = this.request.ammountOfDamage;
			entity.vendorRepayment = this.request.vendorRepayment;
			entity.insuranceRepayment = this.request.insuranceRepayment;
			entity.authorContragentId = this.request.authorContragentId;
			entity.initTypeId = this.request.initTypeId;
			entity.carrierId = this.request.carrierId;
			entity.trackNumber = this.request.trackNumber;
			entity.reclamationDeviceId = this.request.reclamationDeviceId;
			entity.responsibleUserId = this.request.responsibleUserId;
			entity.costCenterId = this.request.costCenterId;
			entity.paymentTypeId = this.isSkipInventoryServiceCenter
				? <number>PaymentTypeEnum.online
				: this.request.paymentTypeId;
			this.requestsService.update(entity, null, false, false).subscribe(() => {
				this.requestsService.getBwtById(this.request.requestId).subscribe(updatedRequest => {
					this.requestUpdateEvent.emit(updatedRequest.entity);
					this.request = updatedRequest.entity;
					this.prepareRequestData();
					this.dataSaving = false;
					this.isEditing = false;
				});
			}, () => { this.dataSaving = false; this.isEditing = false; });
		});
	}

	beforeChangeStatus() {
		this.dataSaving = true;
	}

	cancelChangeStatus() {
		this.dataSaving = false;
	}

	afterChangeStatus() {
		this.requestsService.getBwtById(this.request.requestId).subscribe(updatedRequest => {
			this.requestUpdateEvent.emit(updatedRequest.entity);
			this.request = updatedRequest.entity;
			this.prepareRequestData();
			this.dataSaving = false;
			this.isEditing = false;
		});
	}

	refreshRequest(event: any) {
		this.requestUpdateEvent.emit(event);
	}

	onPaymentStatusChanged(_event: RequestBwt): void {
		this.requestsService.getBwtById(this.request.requestId).subscribe(updatedRequest => {
			this.requestUpdateEvent.emit(updatedRequest.entity);
			this.request = updatedRequest.entity;
			this.prepareRequestData();
		});
	}

	openContragentModal() {
		const dialogRef = this.dialogService.open({ content: CreateContragentComponent, width: '60%', height: '640px' });
		const createContragentForm = <CreateContragentComponent>dialogRef.content.instance;
		
		createContragentForm.isEditing = true;
		createContragentForm.contragentEntity = this.selectedContragent;
		createContragentForm.onCancelEvent.subscribe(() => dialogRef.close());
		createContragentForm.onContinueEvent.subscribe((contragent) => {
			this.selectedContragent = contragent;
			this.requestsService.getBwtById(this.request.requestId).subscribe(updatedRequest => {
				this.requestUpdateEvent.emit(updatedRequest.entity);
				this.request = updatedRequest.entity;
				this.prepareRequestData();
				dialogRef.close();
			});		
		});
	}

	performerUserGroupChange(groupId: number): void {
		if (groupId) {
			this.loadPerformerUsers(groupId);
		}		
	}

	loadPerformerUsers(groupId: number): void {
		if (groupId) {
			this.usersService.getUsersByGroup(groupId).subscribe(data => this.performersByGroup = data);
		}
	}

	editRequest() {
		if (!this.isEditing) {
			this.savedServiceCenterId = this.request ? this.request.serviceCenterId : null;
			this.isEditing = true;
			return;
		}

		if (this.request) {
			this.request.serviceCenterId = this.savedServiceCenterId;
		}
		this.isEditing = false;
	}

	issueInvoice() {
		Swal({
			title: 'Пожалуйста, подождите...',
			html: 'Формирование счета...',
			allowOutsideClick: false,
			showConfirmButton: false,
			onOpen: () => {
				Swal.showLoading();
			}
		});

		this.invoiceLoading = true;
		this.paymentsService.createOrder(this.request.requestId).subscribe((res) => {
			this.invoiceLoading = false;
			if (res.isSuccessful) {
				Swal.close();
				
				this.requestsService.getBwtById(this.request.requestId).subscribe(updatedRequest => {
						this.requestUpdateEvent.emit(updatedRequest.entity);
						this.request = updatedRequest.entity;
						this.prepareRequestData();
					});

				this.attachmentsService.getById(res.data).subscribe(attachment => {
					const dialogRef = this.dialogService.open({ content: DocumentSender, width: this.appService.isMobileDevice ? '90%' : '90%', height: '90%', title: 'Изображение'});
					
					const documentSender = <DocumentSender>dialogRef.content.instance;
			
					documentSender.requestId = this.request.requestId;
					documentSender.fileId = res.data;
					documentSender.requestId = this.request.requestId;
					documentSender.files = [attachment.entity];
					documentSender.hidePreviousAndNexImageButtons = true;
					documentSender.noBl = true;
					documentSender.mailSended.subscribe((res: Sended) => {
						if (res.isSuccessful) {
							this.notificationService.success({ title: 'Отправка Email', message: 'Email отправлен', notificationType: NotificationType.SweetAlert });
						}
					});
				});
			}
		}, () => {this.invoiceLoading = false; });
	}

	getRequestStatusName(statusId: number): string {
		return this.requestStatuses.some(x => x.id == statusId)
			? this.requestStatuses.find(x => x.id == statusId).name
			: '';
	}

	requestTypeChange(requestTypeId: number) {
		this.dependentRequestCategories = requestTypeId != null && requestTypeId != 0
			? this.requestCategories.filter(x => x.requestTypeIds.some(rt => rt == requestTypeId) && !x.disabledForCurrentUser)
			: this.requestCategories;
		this.request.requestCategoryId = this.dependentRequestCategories.length == 1
			? this.dependentRequestCategories[0].id
			: null;

		this.usersService.getRequestTypeResponsibleUsers(requestTypeId).subscribe(resp => {
			this.responsibleUsers = resp;

			if (resp.length == 1) {
				this.request.responsibleUserId = resp[0].id;
			}
			else if (!resp.some(x => x.id == this.request.responsibleUserId)) {
				this.request.responsibleUserId = null;
			}
		})
    }

	prepareRequestData() {
		this.formatDates();
		this.requestDescriptionChange();
	}

	requestDescriptionChange() {
		if (this.request.description != null) {
			this.descriptionInputRows = this.request.description.split('\n').length;
		}
	}

	formatDates() {
		this.request.createdDate = new Date(this.request.createdDate);
		if (this.request.finishDate != null) {
			this.request.finishDate = new Date(this.request.finishDate);
		}
	}

	editRequestWaterSampling() {
		if (this.request.requestWaterSamplingData && this.request.requestWaterSamplingData.requestWaterSamplingActId) {
			const dialogRef = this.dialogService.open({
				content: CreateRequestWaterSamplingActComponent,
				width: 1200,
				height: 840
			});

			const dialog = <CreateRequestWaterSamplingActComponent>dialogRef.content.instance;
			dialog.contentHeight = 720;
			dialog.requestId = this.request.requestId;
			dialog.requestCategoryId = this.request.requestCategoryId;
			dialog.contragentId = this.request.customerContragentId;
			dialog.customerObjectId = this.request.customerObjectId;

			dialog.onCancelEvent.subscribe(() => {
				dialogRef.close();
				this.loadRequestWaterSamplingData();
			});
			dialog.onContinueEvent.subscribe(() => {
				dialogRef.close();
				this.loadRequestWaterSamplingData();
			});
		}
		else {
			const dialogRef = this.dialogService.open({
				content: CreateRequestWaterSamplingComponent,
				width: 1200,
				height: 760
			});
	
			const dialog = <CreateRequestWaterSamplingComponent>dialogRef.content.instance;
			dialog.contentHeight = 640;
			dialog.requestId = this.request.requestId;
	
			dialog.onCancelEvent.subscribe(() => {
				dialogRef.close();
				this.loadRequestWaterSamplingData();
			});
			dialog.onContinueEvent.subscribe(() => {
				dialogRef.close();
				this.loadRequestWaterSamplingData();
			});
		}
	}

    getNameById(items: KeyValueObject[] = [], id: number): string {
        return items.some(x => x.id == id)
            ? items.find(x => x.id == id).name
            : '';
    }

	changeTrackNumber(trackNumber: string) {
		if (trackNumber != null && 
			trackNumber.trim() != '' && 
			this.request.carrierId == null && 
			this.carriers.length == 1) 
		{
			this.request.carrierId = this.carriers[0].id;
		}
	}

	loadRequestClaimDevices() {
		this.requestClaimDevicesLoading = true;
		this.requestDevicesService.getRequestClaimDevices(this.request.requestId).subscribe(resp => {
			this.requestClaimDevices = resp;
			this.requestClaimDevicesLoading = false;
			this.requestClaimDevices.forEach(x => x.manufactureDate = this.appService.parseDate(x.manufactureDate));
		}, () => this.requestClaimDevicesLoading = false);
	}
	
	createNewClaimDevice(): RequestClaimDevice {
		let device = new RequestClaimDevice();
		return device;
	}

	saveClaimDevice({ dataItem }) {
		this.requestClaimDevicesLoading = true;
		this.requestDevicesService.updateRequestClaimDevice(dataItem).subscribe(resp => {
			this.loadRequestClaimDevices();
		}, () => this.requestClaimDevicesLoading = false);
	}

	createNewReclamationDevice(): RequestReclamationDeviceDto {
		let device = new RequestReclamationDeviceDto();
		return device;
	}
	
	addNewReclamationDevice() {
		this.reclamationDevicesGrid.addRow(this.createNewReclamationDevice());
	}

	getReclamationDeviceName(reclamationDeviceId: number): string {
        return reclamationDeviceId ?
            this.reclamationDevices.find(x => x.reclamationDeviceId == reclamationDeviceId).name
            : '';
    }

	handleReclamationDevicesDropdownOpen(reclamationProductGroupId: number) {
        this.reclamationDevicesDropdownData = this.reclamationDevices
            .filter(x => x.reclamationProductGroupId == reclamationProductGroupId)
            .map(x => new KeyValueObject(x.reclamationDeviceId, x.name));
    }

    changeReclamationProductGroupd(groupId: number, dataItem: RequestReclamationDeviceDto) {
        dataItem.reclamationDeviceId = null;
    }

	saveRequestReclamationDevice({ dataItem }) {
		this.request.reclamationDeviceId = dataItem.reclamationDeviceId;

		this.requestClaimDevicesLoading = true;
		const saveRequests: Observable<any>[] = [
			this.reclamationDevicesService.updateReclamationRequestDevice(this.request.requestId, dataItem.reclamationDeviceId)
		];
		const claimDeviceAction = this.createOrUpdateClaimDeviceFromReclamation(dataItem.reclamationDeviceId);
		if (claimDeviceAction != null) {
			saveRequests.push(claimDeviceAction);
		}

		forkJoin(saveRequests).subscribe(() => {
			this.loadRequestClaimDevices();
		}, () => this.requestClaimDevicesLoading = false);

		this.requestsService.getRequestProblems(this.request.requestId, dataItem.reclamationDeviceId).subscribe(resp => {
			this.problems = resp.data;
			if (!this.problems.some(x => x.id == this.request.claimId)) {
				this.request.claimId = null;
			}
		});
	}

	createOrUpdateClaimDeviceFromReclamation(reclamationDeviceId: number): Observable<any> {
		let reclamationDeviceModel = this.reclamationDeviceModels.find(x => x.reclamationDeviceId == reclamationDeviceId);
		if (reclamationDeviceModel == null) {
			return null;
		}

		let requestClaimDevice = this.requestClaimDevices.length > 0
			? this.requestClaimDevices[0]
			: new RequestClaimDevice();

		requestClaimDevice.requestId = this.request.requestId;
		requestClaimDevice.deviceModelId = reclamationDeviceModel.deviceModelId;
		if (!requestClaimDevice.claimedDeviceQuantity) {
			requestClaimDevice.claimedDeviceQuantity = this.request.claimedDeviceQuantity || 1;
		}

		this.request.claimedDeviceQuantity = requestClaimDevice.claimedDeviceQuantity;

		return requestClaimDevice.requestDeviceId
			? this.requestDevicesService.updateRequestClaimDevice(requestClaimDevice)
			: this.requestDevicesService.createRequestClaimDevice(requestClaimDevice);
	}

	removeRequestReclamationDevice({ dataItem }) {
		this.request.reclamationDeviceId = null;
		this.problems = [];
		this.request.claimId = null;
	}

	routeToContragent() {
		if (this.request.customerContragentId != null) {
			window.open(`/categories/contragent/${this.request.customerContragentId}`, '_blank');
		}
	}

	get isReclamation(): boolean {
		return this.request.requestTypeId == <number>RequestType.reclamation;
	}

	get isLaboratory(): boolean {
		return this.request.requestTypeId == <number>RequestType.laboratory;
	}

	get isPersonalWarehouseReplenishment(): boolean {
		return this.request.requestTypeId === <number>RequestType.personalWarehouseReplenishment;
	}

	get canFullyEditRequest(): boolean {
		return this.request == null || this.request.canFullyEditRequest !== false;
	}

	get isEditingMainFields(): boolean {
		return this.isEditing && this.canFullyEditRequest;
	}

	get canEditServiceCenter(): boolean {
		return this.isEditing;
	}

	get customerContragentName(): string {
		return this.selectedContragent
			? this.selectedContragent.isIndividual 
				? this.selectedContragent.contactFullName
				: this.selectedContragent.name
			: this.request
				? this.request.customerContragentName
				: '';
	}

	get customerContragentAddressValue(): string {
		if (this.request == null || this.request.customerObjectAddress == null) {
			return '-';
		}

		return this.request.customerContragentAddressDescription != null
			? `${this.request.customerContragentAddress}, пом. ${this.request.customerContragentAddressDescription}`
			: this.request.customerContragentAddress;
	}	

	get requestStatusesByWorkflowTransitions(): KeyValueObject[] {
		let requestStatuses = [
			new KeyValueObject(this.request.requestStatusId, this.request.requestStatusName)
		];
		this.request.workflowTransitions.map(x => {
			requestStatuses.push(
				new KeyValueObject(x.requestStatusToId, this.getRequestStatusName(x.requestStatusToId)));
		});
		return requestStatuses;
	}

	get canSave(): boolean {
		return !this.entityForm.pristine && this.entityForm.valid;
	}

	get canIssueInvoice(): boolean {
		return this.request != null && this.selectedContragent != null &&
			this.request.paymentStatusId == <number>PaymentStatusEnum.waitIssueInvoice &&
			this.request.paymentTypeId == <number>PaymentTypeEnum.prepayment &&
			!this.selectedContragent.isIndividual;
	}

	get isSkipInventoryServiceCenter(): boolean {
		if (!this.request) {
			return false;
		}

		if (this.request.serviceCenterSkipInventory) {
			return true;
		}

		const selected = (this.serviceCenters || []).find(x => x.id === this.request.serviceCenterId);
		return !!(selected && selected.skipInventory);
	}

	onServiceCenterChange(serviceCenterId: number): void {
		const selected = (this.serviceCenters || []).find(x => x.id === serviceCenterId);
		this.request.serviceCenterSkipInventory = !!(selected && selected.skipInventory);
		this.applySkipInventoryPaymentType();
	}

	private applySkipInventoryPaymentType(): void {
		if (this.isSkipInventoryServiceCenter) {
			this.request.paymentTypeId = <number>PaymentTypeEnum.online;
		}
	}

	get cardMainHeight(): number {
		return this.cardHeight - 30;
	}

	get cardAdditionalHeight(): number {
		return this.cardHeight + 50;
	}

	get cardHeight(): number {
		return (this.blockHeight - 20) / 2;
	}
}